<template>
  <div class="suspended" role="alert" aria-live="assertive">
    <HEmptyState
      title="Online bookings are temporarily unavailable"
      description="Online bookings are temporarily unavailable. Please contact the venue."
      :icon="false"
    />
  </div>
</template>

<script setup lang="ts">
/**
 * Shown INSTEAD of the booking pages when the API answers 402 `org_suspended` (the venue's Hospora account has an
 * overdue invoice). Guests get a neutral line only: nothing about billing, and no way past it. App.vue renders it
 * in place of the router view, inside the usual venue header and footer.
 */
import { HEmptyState } from '@hospora/ui'
</script>

<style scoped>
.suspended {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: min(70vh, 32rem);
  padding: var(--h-space-4, 1rem);
  text-align: center;
}
</style>
